module.exports = __webpack_public_path__ + "img/2f891a7.jpg";